/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PerformanceManagementAlert', 'model/PerformanceManagementAlertReportNestedPaginationSlice', 'model/PerformanceManagementAlertReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/PerformanceManagementAlert'), require('../model/PerformanceManagementAlertReportNestedPaginationSlice'), require('../model/PerformanceManagementAlertReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceManagementAlertApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PerformanceManagementAlert, root.ForStractionServiceApi.PerformanceManagementAlertReportNestedPaginationSlice, root.ForStractionServiceApi.PerformanceManagementAlertReport);
  }
}(this, function(ApiClient, PerformanceManagementAlert, PerformanceManagementAlertReportNestedPaginationSlice, PerformanceManagementAlertReport) {
  'use strict';

  /**
   * PerformanceManagementAlert service.
   * @module api/PerformanceManagementAlertApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new PerformanceManagementAlertApi. 
   * @alias module:api/PerformanceManagementAlertApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the performanceManagementAlertAddPut operation.
     * @callback module:api/PerformanceManagementAlertApi~performanceManagementAlertAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/PerformanceManagementAlert} body 
     * @param {module:api/PerformanceManagementAlertApi~performanceManagementAlertAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.performanceManagementAlertAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceManagementAlertAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/PerformanceManagementAlert/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceManagementAlertCreateAlertFromStrategyGet operation.
     * @callback module:api/PerformanceManagementAlertApi~performanceManagementAlertCreateAlertFromStrategyGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * createAlertFromStrategy
     * @param {String} _4SAPIAppID 
     * @param {Integer} strategyID 
     * @param {module:api/PerformanceManagementAlertApi~performanceManagementAlertCreateAlertFromStrategyGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceManagementAlertCreateAlertFromStrategyGet = function(_4SAPIAppID, strategyID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertCreateAlertFromStrategyGet";
      }

      // verify the required parameter 'strategyID' is set
      if (strategyID == undefined || strategyID == null) {
        throw "Missing the required parameter 'strategyID' when calling performanceManagementAlertCreateAlertFromStrategyGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'strategyID': strategyID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceManagementAlert/createAlertFromStrategy', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceManagementAlertCreateLoginURLGet operation.
     * @callback module:api/PerformanceManagementAlertApi~performanceManagementAlertCreateLoginURLGetCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * createLoginURL
     * @param {String} _4SAPIAppID 
     * @param {Integer} batchID 
     * @param {Integer} userID 
     * @param {module:api/PerformanceManagementAlertApi~performanceManagementAlertCreateLoginURLGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.performanceManagementAlertCreateLoginURLGet = function(_4SAPIAppID, batchID, userID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertCreateLoginURLGet";
      }

      // verify the required parameter 'batchID' is set
      if (batchID == undefined || batchID == null) {
        throw "Missing the required parameter 'batchID' when calling performanceManagementAlertCreateLoginURLGet";
      }

      // verify the required parameter 'userID' is set
      if (userID == undefined || userID == null) {
        throw "Missing the required parameter 'userID' when calling performanceManagementAlertCreateLoginURLGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'batchID': batchID,
        'userID': userID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/PerformanceManagementAlert/createLoginURL', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceManagementAlertDeleteGet operation.
     * @callback module:api/PerformanceManagementAlertApi~performanceManagementAlertDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} alertID 
     * @param {module:api/PerformanceManagementAlertApi~performanceManagementAlertDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceManagementAlertDeleteGet = function(_4SAPIAppID, alertID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertDeleteGet";
      }

      // verify the required parameter 'alertID' is set
      if (alertID == undefined || alertID == null) {
        throw "Missing the required parameter 'alertID' when calling performanceManagementAlertDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'alertID': alertID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceManagementAlert/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceManagementAlertEditPut operation.
     * @callback module:api/PerformanceManagementAlertApi~performanceManagementAlertEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/PerformanceManagementAlert} body 
     * @param {module:api/PerformanceManagementAlertApi~performanceManagementAlertEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceManagementAlertEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceManagementAlertEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceManagementAlert/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceManagementAlertEvaluateGet operation.
     * @callback module:api/PerformanceManagementAlertApi~performanceManagementAlertEvaluateGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * evaluate
     * @param {String} _4SAPIAppID 
     * @param {Integer} alertID 
     * @param {Integer} value 
     * @param {String} comment 
     * @param {module:api/PerformanceManagementAlertApi~performanceManagementAlertEvaluateGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceManagementAlertEvaluateGet = function(_4SAPIAppID, alertID, value, comment, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertEvaluateGet";
      }

      // verify the required parameter 'alertID' is set
      if (alertID == undefined || alertID == null) {
        throw "Missing the required parameter 'alertID' when calling performanceManagementAlertEvaluateGet";
      }

      // verify the required parameter 'value' is set
      if (value == undefined || value == null) {
        throw "Missing the required parameter 'value' when calling performanceManagementAlertEvaluateGet";
      }

      // verify the required parameter 'comment' is set
      if (comment == undefined || comment == null) {
        throw "Missing the required parameter 'comment' when calling performanceManagementAlertEvaluateGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'alertID': alertID,
        'value': value,
        'comment': comment
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceManagementAlert/evaluate', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceManagementAlertLoadAlertBatchSlicesPut operation.
     * @callback module:api/PerformanceManagementAlertApi~performanceManagementAlertLoadAlertBatchSlicesPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PerformanceManagementAlertReportNestedPaginationSlice>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAlertBatchSlices
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startRow  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.slicingOrder  (default to 0)
     * @param {module:api/PerformanceManagementAlertApi~performanceManagementAlertLoadAlertBatchSlicesPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PerformanceManagementAlertReportNestedPaginationSlice>}
     */
    this.performanceManagementAlertLoadAlertBatchSlicesPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertLoadAlertBatchSlicesPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceManagementAlertLoadAlertBatchSlicesPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startRow': opts['startRow'],
        'maxCount': opts['maxCount'],
        'slicingOrder': opts['slicingOrder']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PerformanceManagementAlertReportNestedPaginationSlice];

      return this.apiClient.callApi(
        '/PerformanceManagementAlert/loadAlertBatchSlices', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceManagementAlertLoadAllUnbatchedAlertsGet operation.
     * @callback module:api/PerformanceManagementAlertApi~performanceManagementAlertLoadAllUnbatchedAlertsGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PerformanceManagementAlertReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAllUnbatchedAlerts
     * @param {String} _4SAPIAppID 
     * @param {module:api/PerformanceManagementAlertApi~performanceManagementAlertLoadAllUnbatchedAlertsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PerformanceManagementAlertReport>}
     */
    this.performanceManagementAlertLoadAllUnbatchedAlertsGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertLoadAllUnbatchedAlertsGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PerformanceManagementAlertReport];

      return this.apiClient.callApi(
        '/PerformanceManagementAlert/loadAllUnbatchedAlerts', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceManagementAlertReviewAndSendPut operation.
     * @callback module:api/PerformanceManagementAlertApi~performanceManagementAlertReviewAndSendPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerformanceManagementAlertReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * reviewAndSend
     * @param {String} _4SAPIAppID 
     * @param {module:model/PerformanceManagementAlertReport} body 
     * @param {module:api/PerformanceManagementAlertApi~performanceManagementAlertReviewAndSendPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerformanceManagementAlertReport}
     */
    this.performanceManagementAlertReviewAndSendPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertReviewAndSendPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceManagementAlertReviewAndSendPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = PerformanceManagementAlertReport;

      return this.apiClient.callApi(
        '/PerformanceManagementAlert/reviewAndSend', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceManagementAlertSendPreviewGet operation.
     * @callback module:api/PerformanceManagementAlertApi~performanceManagementAlertSendPreviewGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendPreview
     * @param {String} _4SAPIAppID 
     * @param {Integer} alertID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.userID 
     * @param {module:api/PerformanceManagementAlertApi~performanceManagementAlertSendPreviewGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceManagementAlertSendPreviewGet = function(_4SAPIAppID, alertID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertSendPreviewGet";
      }

      // verify the required parameter 'alertID' is set
      if (alertID == undefined || alertID == null) {
        throw "Missing the required parameter 'alertID' when calling performanceManagementAlertSendPreviewGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'alertID': alertID,
        'userID': opts['userID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceManagementAlert/sendPreview', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceManagementAlertSendReportPut operation.
     * @callback module:api/PerformanceManagementAlertApi~performanceManagementAlertSendReportPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerformanceManagementAlertReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendReport
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Integer} alertID 
     * @param {Date} period 
     * @param {String} coverLetter 
     * @param {module:api/PerformanceManagementAlertApi~performanceManagementAlertSendReportPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerformanceManagementAlertReport}
     */
    this.performanceManagementAlertSendReportPut = function(_4SAPIAppID, body, alertID, period, coverLetter, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertSendReportPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceManagementAlertSendReportPut";
      }

      // verify the required parameter 'alertID' is set
      if (alertID == undefined || alertID == null) {
        throw "Missing the required parameter 'alertID' when calling performanceManagementAlertSendReportPut";
      }

      // verify the required parameter 'period' is set
      if (period == undefined || period == null) {
        throw "Missing the required parameter 'period' when calling performanceManagementAlertSendReportPut";
      }

      // verify the required parameter 'coverLetter' is set
      if (coverLetter == undefined || coverLetter == null) {
        throw "Missing the required parameter 'coverLetter' when calling performanceManagementAlertSendReportPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'alertID': alertID,
        'period': period,
        'coverLetter': coverLetter
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = PerformanceManagementAlertReport;

      return this.apiClient.callApi(
        '/PerformanceManagementAlert/sendReport', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceManagementAlertSendReviewGet operation.
     * @callback module:api/PerformanceManagementAlertApi~performanceManagementAlertSendReviewGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerformanceManagementAlertReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendReview
     * @param {String} _4SAPIAppID 
     * @param {Integer} alertID 
     * @param {Date} period 
     * @param {String} coverLetter 
     * @param {module:api/PerformanceManagementAlertApi~performanceManagementAlertSendReviewGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerformanceManagementAlertReport}
     */
    this.performanceManagementAlertSendReviewGet = function(_4SAPIAppID, alertID, period, coverLetter, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertSendReviewGet";
      }

      // verify the required parameter 'alertID' is set
      if (alertID == undefined || alertID == null) {
        throw "Missing the required parameter 'alertID' when calling performanceManagementAlertSendReviewGet";
      }

      // verify the required parameter 'period' is set
      if (period == undefined || period == null) {
        throw "Missing the required parameter 'period' when calling performanceManagementAlertSendReviewGet";
      }

      // verify the required parameter 'coverLetter' is set
      if (coverLetter == undefined || coverLetter == null) {
        throw "Missing the required parameter 'coverLetter' when calling performanceManagementAlertSendReviewGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'alertID': alertID,
        'period': period,
        'coverLetter': coverLetter
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = PerformanceManagementAlertReport;

      return this.apiClient.callApi(
        '/PerformanceManagementAlert/sendReview', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
